import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { PageLoader } from '../../../../shared_elements';
import { Tooltip } from '@material-ui/core';
import { globalGetService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import EditInsuranceCard from './InsuranceCardEdit';
export default function InsuranceCard({ props, getResponseBack }) {
    const [editModal, setEditModal] = useState({ modal: false });
    const [insuranceCard, setInsuranceCard] = useState({});
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getInsuranceCard();
    }, [])
    const toggleEditSideBar = (data) => {
        setEditModal({ modal: true, data: insuranceCard })
    }
    const getInsuranceCard = () => {
        setLoading(true);
        globalGetService(`/contracts/${props.params.contract_slug}/contract-insurance/`)
            .then((response) => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    setInsuranceCard(response?.data.data);
                } else {
                    toastFlashMessage(response?.data.message, 'error');
                }
            })
    }
    const updateInsuranceCard = (data) => {
        setLoading(true);
        globalPutService(`contracts/${props.params.contract_slug}/contract-insurance/`, data)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEditModal({ modal: false });
                    getInsuranceCard();
                    setLoading(false);
                    toastFlashMessage('Security Deposit Currency Details Updated Successfully', 'success');
                    window.location.reload()
                } else {
                    setLoading(false);
                    toastFlashMessage('Error Occured while updating Security Deposit Currency Details', 'error');
                }
            }
            )
    }
    return (
        <>
            <div className="data-invoice-block" style={{ marginBottom: '16px', height: '200px' }}>
                {checkPermission('contracts', 'insurance', 'U') ?
                    <h5 className="para">
                        <Tooltip title="Edit Security Currency Details" placement="top">
                            <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" className="editIcon" src={editIconWhite} alt="img" />
                        </Tooltip>
                    </h5> : null}
                <Row>
                    <InvoiceConfigCol
                        size="4"
                        title="Agreed Value as per the Lease Agreement"
                        value={insuranceCard?.insurance_titan_extra_fields?.agreed_value_per_lease_agreement || 'N/A'}
                    />
                    <InvoiceConfigCol
                        size="4"
                        title="Depreciation Per Year"
                        value={insuranceCard?.insurance_titan_extra_fields?.depreciation_per_year || 'N/A'}
                    />
                    <InvoiceConfigCol
                        size="12"
                        title="Remarks"
                        value={insuranceCard?.insurance_titan_extra_fields?.insurance_remarks || '--'}
                    />
                </Row>
            </div>
            {editModal.modal ?
                <EditSidebar
                    title={`Edit Security Currency Details`}
                    editSideBar={editModal?.modal}
                    toggleEditSideBar={() => setEditModal({ modal: false })}
                >
                    <EditInsuranceCard
                        type="edit"
                        insuranceCard={insuranceCard}
                        toggleEditSideBar={() => setEditModal({ modal: false })}
                        updateInsuranceCard={(data) => updateInsuranceCard(data,)}
                    />
                </EditSidebar> : null}
            {isLoading ? <PageLoader /> : null}
        </>
    )
}